<template>
  <div class="inquiry_create home_page">
    <el-header class="right-menu-name" height="40px">
      <el-breadcrumb separator="/" style="line-height:40px">
        <!-- <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item> -->
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div class="create_content">
      <h1>{{this.inquiryId ? '编辑询价单' : '新增询价单'}}</h1>
      <el-form :model="dataForm" ref="dataForm" label-width="100px" label-position="top">
        <el-form-item label="商品：">
          <el-row :gutter="20">
            <el-col :span="8" v-for="item in goodList" :key="item.skuId">
              <div class="good_detail">
                <div class="cursor-pointer good_img"
                     @click="goodDetail(item)">
                  <img :src="item.fileUrl|| item.skuUrl"
                     :alt="item.skuName"
                     height="184px"
                     width="100%"/>
                </div>
                <div class="good_info">
                  <h3 class="ellipsis">{{item.skuName}}</h3>
                  <div>商品编号：&nbsp;&nbsp;{{item.skuCode}}</div>
                  <!-- <div>数量：&nbsp;&nbsp;{{item.count}}</div> -->
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="备注信息：">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4}"
            :maxlength="200"
            :disabled="loading"
            placeholder="请输入内容"
            v-model="dataForm.remark">
          </el-input>
        </el-form-item>
        <el-form-item label="询价附件：">
          <el-upload
            class="upload-demo"
            ref="uploadFile"
            :action="actionUrl"
            :disabled="loading"
            :on-preview="handlePreview"
            :before-remove="beforeRemove"
            :before-upload="beforeUpload"
            :data="{ fileSuffixType: 'allType' }"
            :accept="'.jpg,.jpeg,.png,.gif,.bmp,.xls,.xlsx,.doc,.docx,.csv,.txt,.pdf,.zip,.rar,.ppt,.pptx'"
            :with-credentials="true"
            :headers="upLoadHeaders"
            :limit="1"
            :on-exceed="handleExceed"
            :on-success="successHandle"
            :on-error="errorHandle"
            :file-list="fileList">
            <el-button size="small"
                       type="primary"
                       v-show="dataForm.sysOssEntities.length < 1">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </el-form-item>
        <el-form-item class="text-center">
          <el-button class="but_plant" @click="cancleHandle()" :disabled="loading" :loading="loading">取消</el-button>
          <el-button class="but_plant" type="primary" @click="submitHandle()" :disabled="loading" :loading="loading">提交</el-button>
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
import { openOther } from '@/utils'
export default {
  data () {
    return {
      loading: false,
      dataForm: {
        remark: '',
        inquirySheetCommodityForms: [],
        sysOssEntities: [], // 附件
        inquiryCart: false // 是否询价篮
      },
      goodList: [], // 询价商品信息
      // 上传路径
      actionUrl: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload',
      upLoadHeaders: {
        'Authorization': 'Bearer ' + getAccessToken()
      },
      fileList: [],
      delUrls: []
    }
  },
  computed: {
    inquiryId () {
      return this.$route.query.id || ''
    },
    inquirySheetCommodityForms () {
      let goodList = []
      let list = this.$route.query.goodList || ''
      list.split(';').forEach(item => {
        if (item) {
          let good = item.split(',')
          goodList.push({
            spuId: good[0] || '',
            skuId: good[1] || '',
            count: good[2] || 1
          })
        }
      })
      return goodList
    }
  },
  mounted () {
    this.$refs.uploadFile.clearFiles()
    this.fileList = []
    this.goodList = []
    this.delUrls = []
    this.dataForm.remark = ''
    this.dataForm.inquirySheetCommodityForms = []
    this.dataForm.sysOssEntities = []
    this.dataForm.inquiryCart = !!this.$route.query.inquiryCart
    if (this.inquiryId) {
      this.getInquiryInfo()
    } else {
      this.getGoodList()
    }
    if (this.$refs.uploadFile) {
      this.$refs.uploadFile.clearFiles()
    }
  },
  methods: {
    getGoodList () {
      this.goodList = []
      this.$http.post(`/front/consumer/inquirysheet/getCommodityByIds`,
        this.inquirySheetCommodityForms.map(item => {
          return {
            skuId: item.skuId,
            goodNum: item.count
          }
        })
      )
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.goodList = res.data || []
        })
    },
    // 获取询价单详情
    getInquiryInfo () {
      this.$request.get(`/front/consumer/inquirysheet/inquirySheetInfo/${this.inquiryId}`)
        .then((res) => {
          this.goodList = res.commodityVos || []
          this.dataForm.remark = res.remark || ''
          this.dataForm.inquirySheetCommodityForms = []
          let list = res.sysOssEntities || []
          if (list.length) {
            list.forEach(item => {
              item.name = item.fileName
            })
          }
          this.fileList = list
          this.dataForm.sysOssEntities = list.map(item => {
            return {
              aliOssId: item.aliOssId
            }
          })
        })
    },
    // 点击查看图片
    handlePreview (file) {
      if (file.response) {
        openOther(file.response.data.url, true)
      } else {
        openOther(file.url, true)
      }
    },
    beforeUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
      return isLt2M
    },
    // 图片附件溢出提示
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    // 删除图片
    beforeRemove (file, fileList) {
      if (!file.response) {
        // 已保存关联的
        // this.deleteHandle([file.aliOssId])
        this.delUrls.push(file.aliOssId)
        this.dataForm.sysOssEntities.splice(
          this.dataForm.sysOssEntities.findIndex(item => {
            return item.aliOssId === file.aliOssId
          }), 1)
      } else {
        // 未与询价单保存关联的
        this.deleteHandle([file.response.data.aliOssId])
        this.dataForm.sysOssEntities.splice(
          this.dataForm.sysOssEntities.findIndex(item => {
            return item.aliOssId === file.response.data.aliOssId
          }), 1)
      }
    },
    successHandle (response, file) {
      if (response.code === 0) {
        this.dataForm.sysOssEntities.push({ aliOssId: response.data.aliOssId })
      } else {
        this.$refs.uploadFile.uploadFiles.pop()
        this.$message.error(response.message || '上传失败')
      }
    },
    errorHandle (err, file) {
      this.$message.error(err.message || '上传失败')
    },
    cancleHandle () {
      this.$router.go(-1)
    },
    // 提交
    submitHandle () {
      if (!this.dataForm.remark && !this.dataForm.sysOssEntities.length) {
        this.$message.error('请填写备注信息或上传询价附件')
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      this.$http.post(`/front/consumer/inquirysheet/${this.inquiryId ? 'updateInquirySheet' : 'saveInquirySheet'}`, {
        inquiryId: this.inquiryId || 0,
        inquiryCart: this.dataForm.inquiryCart,
        inquirySheetCommodityForms: this.inquirySheetCommodityForms,
        sysOssEntities: this.dataForm.sysOssEntities,
        remark: this.dataForm.remark
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          if (this.delUrls.length) {
            this.deleteHandle(this.delUrls)
          }
          this.$message.success(res.message)
          this.$router.replace({
            name: 'inquiryList'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 删除阿里图片
    deleteHandle (ids = []) {
      if (ids.length) {
        this.$http.post(`help/fileupload/sys/deleteBatchAliOss`, ids)
      }
    },
    // 跳转查看商品详情
    goodDetail (good) {
      openOther(`goodDetail?spuId=${good.spuId}&skuId=${good.skuId}`)
    }
  }
}
</script>
<style lang='scss' scoped>
.inquiry_create{
  .create_content{
    background-color: #fff;
    padding: 30px 125px;
    .but_plant{
      min-width: 100px;
    }
    .good_detail{
      border: 1px solid #ddd;
      line-height: 20px;
      color: #999;
      .good_img{
        margin: 0 auto;
        width: 247px;
        height: 184px;
      }
      .good_info{
        border-top: 1px solid #ddd;
        width: 100%;
        padding: 15px 10px;
      }
      h3{
        color: #333;
      }
    }
  }
}
</style>
